

















































































































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useRouter, useJSURL } from '@ideavivat/vivat-2';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import PanelWithCopyEntity from '@/components/PanelWithCopyEntity.vue';

import creator from '@/table/creator';

import getTotalFavoriteCreator from '@/gql/getTotalFavoriteCreator.gql';
import getCreators from '@/gql/getCreators.gql';
import CreatorGroupsQuery from '@/gql/getCreatorGroups.gql';
import setFavoriteCreator from '@/gql/setFavoriteCreator.gql';
import setActiveCreator from '@/gql/setActiveCreator.gql';
import deleteCreator from '@/gql/deleteCreator.gql';

import CommonCreatorGroupSelector from '@/components/Selector/CommonCreatorGroupSelect.vue';
import CommonFavoriteFilterSelector from '@/components/Selector/CommonFavoriteFilterSelector.vue';
import CommonFavoriteButton from '@/components/CommonCustomButton/CommonFavoriteButton.vue';
import CommonYearSelector from '@/components/Selector/CommonYearSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import { ToggleButton } from 'vue-js-toggle-button';

import cdn from '@/cdn';
import i18n from '@/i18n';

const List = defineComponent({
  setup() {
    const { result: totalFavoriteCratorResult } = useQuery(getTotalFavoriteCreator);
    const totalFavoriteCreator = useResult(totalFavoriteCratorResult, 0, (data) => data.creators.paginatorInfo);
    const warningFavorite = ref(null);

    const { result: creatorGroupResult } = useQuery(CreatorGroupsQuery);
    const creatorGroups = useResult(creatorGroupResult, {}, (data) => data.creatorGroups);

    // ==== Variables for search ==== //
    const search = reactive({
      text: '',
      group: '',
      year: '',
      fav: 'any',
    });

    // ==== Mutate Favorite Item ==== //
    const changeFavorite = reactive({
      id: undefined,
      status: false,
    });

    const favoriteMutation = useMutation(
      setFavoriteCreator,
      () => ({
        variables: {
          ...changeFavorite,
        },
        refetchQueries: ['getCreators', 'getTotalFavoriteCreator'],
      }),
    );

    function favoriteStar(id: any, status: boolean) {
      if (!status && totalFavoriteCreator.value.total >= 30) (warningFavorite.value as any).open();
      else {
        changeFavorite.id = id;
        changeFavorite.status = !status;
        favoriteMutation.mutate();
      }
    }
    // ============================= //

    // ==== Mutate Active Item ==== //
    const changeActive = reactive({
      id: undefined,
      status: false,
    });

    const activeMutation = useMutation(
      setActiveCreator,
      () => ({
        variables: {
          ...changeActive,
        },
        refetchQueries: ['getCreators'],
      }),
    );

    function setActiveStatus(id: any, status: boolean) {
      changeActive.id = id;
      changeActive.status = status;
      activeMutation.mutate();
    }
    // ============================= //

    // ==== Set message to display on delete dialog ==== //
    const deleteItem = reactive({
      id: '',
      firstName: '',
      lastName: '',
    });
    function setDisplayItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.firstName = item.firstName;
      deleteItem.lastName = item.lastName;
    }
    // ==== Create delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteCreator,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getCreators'],
      }),
    );

    // ==== Redirect to view item page ==== //
    const { router } = useRouter();
    function viewItem(item: any) {
      router.push({ name: 'CreatorView', params: { creatorId: item.item?.id } });
    }

    // ==== Use to search Creator ==== //
    const creatorListVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filterCreatorGroup: undefined,
        filterHonouredYears: undefined,
        searchFirstName: undefined,
        searchLastName: undefined,
        filterFavorite: undefined,
      };
      if (search.text) {
        vars.searchFirstName = `%${search.text}%`;
      }
      if (search.group) {
        vars.filterCreatorGroup = search.group;
      }
      if (search.year) {
        vars.filterHonouredYears = { from: parseInt(search.year, 10) - 543, to: parseInt(search.year, 10) - 543 };
      }
      if (search.fav) {
        vars.filterFavorite = search.fav === 'any' ? undefined : search.fav === 'true';
      }
      return vars;
    });

    const copyingItem = ref({});

    return {
      copyingItem,
      warningFavorite,
      creatorTableOption: creator,
      getCreatorsQuery: getCreators,
      getCreatorsResult: (data: any) => data.creators,
      creatorGroups,
      search,
      favoriteStar,
      setActiveStatus,
      deleteItem,
      setDisplayItem,
      deleteMutation,
      viewItem,
      creatorListVariable,
      cdnAccess: cdn.access,
      i18n,
    };
  },
  components: {
    PanelWithCopyEntity,
    CommonCreatorGroupSelector,
    CommonYearSelector,
    CommonFavoriteFilterSelector,
    CommonFavoriteButton,
    CommonConfirmDialog,
    ToggleButton,
  },
  props: {
    role: {},
  },
});

export default List;
